var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container min-vh-100 vertical-center" }, [
    _c(
      "div",
      { staticClass: "row justify-content-center" },
      _vm._l(_vm.portals, function(portal) {
        return _c(
          "div",
          { key: portal, staticClass: "col-md-4" },
          [
            _c(
              "router-link",
              {
                staticClass: "card text-center cursor-pointer shadow",
                attrs: { to: portal }
              },
              [
                _c("img", {
                  staticClass: "card-img-top",
                  attrs: {
                    src: _vm.portalsConfig[portal].image,
                    alt: _vm.portalsConfig[portal].title
                  }
                }),
                _c("div", { staticClass: "card-body" }, [
                  _c("h4", [_vm._v(_vm._s(_vm.portalsConfig[portal].title))]),
                  _c("p", { staticClass: "card-text mt-1" }, [
                    _vm._v(
                      " " + _vm._s(_vm.portalsConfig[portal].description) + " "
                    )
                  ])
                ])
              ]
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }